import React, { FC } from 'react';
import { Text, View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { font } from '@styles/fonts';
import { SimpleOnPress } from '@interfaces/base';
import { DashboardScope } from '@api/domain/types';
import type { NcFileDashboardResult, DashboardResultImageData } from '@api/domain/types';

import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import type { Rank, RankBadgeVariant, WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import DashboardOverviewBottomBlockRowBadge from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowBadge';
import DashboardOverviewBottomBlockRowValue from '@v2/pages/dashboard/modules/overview/components/DashboardOverview/components/DashboardOverviewBottomBlock/components/DashboardOverviewBottomBlockPanel/components/DashboardOverviewBottomBlockRowValue';
import DashboardRowImage from '@v2/pages/dashboard/common/components/DashboardRowImage';
import DashboardRowWrapper from '@v2/pages/dashboard/common/components/DashboardRowWrapper';
import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';
import { scale } from '@components/frame';

interface DashboardOverviewBottomBlockNcFileRowProps
  extends WithColor,
    SimpleOnPress,
    WithBorderRadiusConfig,
    Pick<NcFileDashboardResult, 'ncFileName' | 'ncFileId' | 'totalTimeTotalInSeconds'> {
  rank: Rank;
  variant: RankBadgeVariant;
  imageHash?: string | null;
  imageData?: DashboardResultImageData | null;
}

const DashboardOverviewBottomBlockNcFileRow: FC<DashboardOverviewBottomBlockNcFileRowProps> = ({
  C,
  rank,
  variant,
  ncFileName,
  totalTimeTotalInSeconds,
  imageHash,
  imageData,
  onPress,
  borderRadiusConfig,
}) => (
  <DashboardRowWrapper
    onPress={onPress}
    testID={TEST_IDS.dashboardOverviewBottomBlock.row(variant, rank)}
    scope={DashboardScope.NcFile}
    borderRadiusConfig={borderRadiusConfig}
  >
    <DashboardOverviewBottomBlockRowBadge rank={rank} variant={variant} />
    <DashboardRowImage imageHash={imageHash} imageData={imageData} />
    <View style={{ flex: 1, marginLeft: scale(8) }}>
      <Text style={[font['Subhead 1 bold'], { color: C('Label/Light/Primary') }]} numberOfLines={1}>
        {ncFileName ?? ''}
      </Text>
    </View>
    <DashboardOverviewBottomBlockRowValue seconds={totalTimeTotalInSeconds ?? 0} variant={variant} />
  </DashboardRowWrapper>
);

export default ColorWrapper(DashboardOverviewBottomBlockNcFileRow);
